import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { BookingService } from '../service/booking.service';
import { HttpService } from '../service/http.service';
import { PaymentToSupplierService } from '../service/payment-to-supplier.service';
import { SchoolInvoiceWithPaymentOrders } from '../school-invoice-with-payment-orders';
import { ToastMessageService } from '../toast-message.service';
import { DecimalValidator } from '../validator/decimal-validator';
import { NumberValidator } from '../validator/number-validator';
import { CurrencyService } from '../service/currency.service';
import { PaymentOrder } from '../payment-order';

@Component({
  selector: 'app-edit-payment-to-supplier',
  templateUrl: './edit-payment-to-supplier.component.html',
  styleUrls: ['./edit-payment-to-supplier.component.css']
})
export class EditPaymentToSupplierComponent implements OnInit {

  paymentForm!: FormGroup;
  submitFail = false;
  invalidAmount = false;
  paymentOrders: PaymentOrder[] = [];
  invoices: SchoolInvoiceWithPaymentOrders[] = [];
  @Output() newSchoolPaymentEvent = new EventEmitter<any>();

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    public bookingService: BookingService,
    private toastService: ToastMessageService,
    public paymentToSupplierService: PaymentToSupplierService,
    public currencyService: CurrencyService
  ) { }

  ngOnInit(): void {
    this.httpService.getSchoolInvoicesWithPaymentOrdersByBookingId(this.bookingService.booking.id!).subscribe(res => {
      for(let invoice of res){
        for(let paymentOrder of invoice.paymentOrders){
          paymentOrder.invoiceNumber = invoice.invoiceNumber;
          paymentOrder.label = paymentOrder.invoiceNumber +  " - " + paymentOrder.amount + " " + paymentOrder.currency.isoCode;
          this.paymentOrders.push(paymentOrder);
        }
      }
    });
    let payment = this.paymentToSupplierService.selectedPayemnt;
    this.paymentForm = this.builder.group({
      paymentOrder: [payment.paidOrder, Validators.required],
      amount: [payment.amount.toFixed(2), Validators.compose([DecimalValidator, NumberValidator])],
      currency: payment.currency,
      date: [moment(payment.date).toDate(), Validators.required],
      paymentType: [payment.paymentType, Validators.required],
      comment: payment.comment
    });
  }

  submit(){
    this.submitFail = false;
    if(this.paymentForm.invalid){
      this.toastService.addError("Error", "Form is not complated correctly.");
      this.submitFail = true;
      return;
    }
    let payment = this.paymentToSupplierService.selectedPayemnt;
    payment.amount = this.paymentForm.value.amount;
    payment.date = moment(this.paymentForm.value.date).utc(true);
    payment.invoiceNumber = this.paymentForm.value.invoiceNumber;
    payment.currency = this.paymentForm.value.currency;
    payment.paidOrder = this.paymentForm.value.paymentOrder;
    payment.comment = this.paymentForm.value.comment;
    payment.paymentType = this.paymentForm.value.paymentType
    this.httpService.putPaymentToSupplier(payment, this.bookingService.booking.id!).subscribe(() => {
      this.toastService.addSuccess("Success", "Invoice successfully updated.");
      this.newSchoolPaymentEvent.emit(null);
    }, error => {
      this.toastService.addError("Error", error.message);
    });
  }

  amountChange(event: any){
    let value = event.target.value as string;
    if(value.includes(",")){
      value = value.replaceAll(",", ".");
      event.target.value = value;
    }
  }

}
